/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogSpenderListInfo = {
    RK: string;
    ADT: ZerogSpenderListInfo.ADT;
    ADDR: string;
    TGU: string;
    TS: string;
    TRXCNT: string;
    TF: string;
    LTRXUT: number;
};

export namespace ZerogSpenderListInfo {

    export enum ADT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

